const constants = {
    FINDING: 'FINDING',
    PENTEST: 'PENTEST',
    ASSET: 'ASSET',
    ASSET_V2: 'ASSET_V2',
    USER_DETAILS: 'USER_DETAILS',
    VULNERABILITY_ASSESSMENT:'VULNERABILITY_ASSESSMENT'
}
export default constants;
